import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import * as axios from 'axios';
import * as R from 'ramda';
import { EndPoints } from '../../constants/api-config';
import * as urls from '../../constants/webapi/auth';

export const Placeholder = () => {
  const location = useLocation();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handlePlaceholderAuth = async () => {
      try {
        // Get URL parameters
        const urlParams = new URLSearchParams(location.search);
        const params = Object.fromEntries(urlParams.entries());
        
        // Extract id from parameters
        const { id, ...queryParams } = params;
        
        if (!id) {
          throw new Error('id parameter is required');
        }

        // Make server request with the parameters as query string
        const response = await axios.get(urls.placeholderAuthUrl(id), { params: queryParams });

        // Extract data from response
        const { userId, jwt, redirectUrl } = response.data;

        // Store the userId in session storage if provided
        if (userId) {
          sessionStorage.setItem("user_id", userId);
        }

        // Store the JWT token (even if null, to clear any existing token)
        sessionStorage.setItem("access_token", jwt || "");
        if (jwt) {
          axios.defaults.headers.common['Authorization'] = "Bearer " + jwt;
        } else {
          // Clear the authorization header if no JWT is provided
          delete axios.defaults.headers.common['Authorization'];
        }

        // Redirect to the specified URL or default to anticipa
        if (redirectUrl) {
          // If it's a full URL, navigate to it
          if (redirectUrl.startsWith('http')) {
            window.location.href = redirectUrl;
          } else {
            // If it's a relative path, use history.push
            history.push(redirectUrl);
          }
        } else {
          // Default redirect to anticipa
          history.push('/anticipa/');
        }

      } catch (err) {
        console.error('Placeholder authentication error:', err);
        setError(err.message || 'Authentication failed');
        setLoading(false);
      }
    };

    handlePlaceholderAuth();
  }, [location, history]);

  if (error) {
    return (
      <div className="layout layout-col bg-gradient-primary">
        <div className="container d-flex align-items-center justify-content-center min-vh-100">
          <div className="text-center">
            <h2 className="text-white mb-4">Félicitations</h2>
            <p className="text-white mb-4">Votre compte Assist@ a été créé</p>
            <p className="text-white mb-4">Vous allez recevoir un mail pour vous connecter. Veuillez consulter votre mail pour continuer.</p>
            
          </div>
        </div>
      </div>
    );
    return (
      <div className="layout layout-col bg-gradient-primary">
        <div className="container d-flex align-items-center justify-content-center min-vh-100">
          <div className="text-center">
            <h2 className="text-white mb-4">Authentication Error</h2>
            <p className="text-white mb-4">{error}</p>
            <button 
              className="btn btn-light" 
              onClick={() => history.push('/auth/signin')}
            >
              Go to Sign In
            </button>
          </div>
        </div>
      </div>
    );
  }

     return (
     <div className="layout layout-col bg-gradient-primary">
       <div className="container d-flex align-items-center justify-content-center min-vh-100">
         <div className="text-center">
           <div className="spinner-border text-light mb-4" role="status">
             <span className="sr-only">Chargement...</span>
           </div>
           {/* <h2 className="text-white mb-4">Redirection en cours</h2> */}
           <p className="text-white">Patientez quelques instants</p>
         </div>
       </div>
     </div>
   );
};
